const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;

if (!clientId && process.env.NODE_ENV === 'production') {
  throw new Error('Missing REACT_APP_AZURE_CLIENT_ID in environment variables');
}

export const msalConfig = {
  auth: {
    clientId: clientId || '',
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
